<div class="notification-dropdown">
  <!-- Loading state -->
   @if (isLoading() && notifications().length === 0) {
  <div class="loading-state">
    <div class="loading-content">
      <app-spinner [size]="32"></app-spinner>
    </div>
  </div>
  }

  <!-- Notifications List -->
  @if (!isLoading() || notifications().length > 0) {
  <div class="notifications-list">
    <!-- Empty state message -->
     @if (notifications().length === 0) {
    <div class="empty-state">
      <div class="empty-icon">
        <i class="fas fa-bell-slash"></i>
      </div>
      <h3 class="empty-title">No new notifications</h3>
      <p class="empty-description">You're all caught up! New notifications will appear here.</p>
    </div>
    }

    <!-- Notification items -->
    <!-- <ng-container *ngFor="let notification of notifications()"> -->
      @for (notification of notifications(); track notification.id) {
      <div class="notification-item" [class.marking-read]="markingAsRead === notification.id"
        (click)="onNotificationClick(notification, $event)" style="cursor: pointer;">
        <!-- Avatar -->
        <div
          [ngClass]="getAvatarClasses(notification.id, !!notification.user.avatar && !imageLoadError[notification.id])">
          @if (notification.user.avatar && !imageLoadError[notification.id]) {
          <img [src]="notification.user.avatar"
            [alt]="notification.user.name" (error)="onImageError(notification.id)"
            (load)="onImageLoad(notification.id)">
          }
          @if (!notification.user.avatar || imageLoadError[notification.id]) {
          <div class="avatar-fallback">
            {{ getInitials(notification.user.name) }}
          </div>
          }
        </div>

        <!-- Notification content -->
        <div class="notification-content">
          <!-- User name and action message -->
          <div class="notification-header">
            <span class="user-name">{{ notification.user.name }}</span>
            @if (notification.title) {
            <div class="notification-title-wrapper">
              <span class="notification-title">{{ toSentenceCase(notification.title) }}</span>
            </div>
            }
          </div>

          <!-- Issue/task/object name (clickable link) -->
           @if (getDisplayName(notification)) {
          <div class="project-name" (click)="onNotificationClick(notification, $event)">
            {{ getDisplayName(notification) }}
          </div>
          }

          <!-- Comment snippet (if available) -->
           @if (notification.description) {
          <div
            class="comment-snippet"
            [innerHTML]="getSafeDescription(notification.description)"
          ></div>
          }

          <div class="notification-timestamp">
            @if (notification.createdAt) {
              <span class="time-value">{{ notification.createdAt | relativeTime }}</span>
            } @else {
              <span class="time-value time-value--fallback">Recently</span>
            }
          </div>
        </div>

        <!-- Mark as read button -->
        <!-- <div class="mark-read-btn" matTooltip="Mark as Seen"
          (click)="markAsSeen(notification); $event.stopPropagation()">
          <i class="fas fa-check"></i>
        </div> -->
      </div>
    <!-- </ng-container> -->
    }
  </div>
  }

  <!-- Footer with View All link -->
  <div class="dropdown-footer">
    <a class="btn-view-all" [href]="notificationsHref" target="_blank" rel="noopener noreferrer" (click)="viewAllNotifications(); $event.stopPropagation()">
      View All
    </a>
    @if (notifications().length > 0) {
    <button type="button" class="btn-cancel" (click)="markAllAsSeen(); $event.stopPropagation()">
      Mark All as Seen
    </button>
    }

  </div>
</div>
